"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OKXInjectWalletName = exports.OKXMiniWalletName = exports.OKXWalletName = void 0;
exports.creatOKXWalletInfo = creatOKXWalletInfo;
exports.creatOKXMiniAppWalletInfo = creatOKXMiniAppWalletInfo;
exports.creatOKXInjectWalletInfo = creatOKXInjectWalletInfo;
exports.OKXWalletName = "OKX Wallet";
exports.OKXMiniWalletName = "OKX Mini Wallet";
exports.OKXInjectWalletName = "OKX Inject Wallet";
function creatOKXWalletInfo() {
    return {
        "appName": "okxAppWallet",
        "name": exports.OKXWalletName,
        "imageUrl": "https://static.okx.com/cdn/assets/imgs/247/58E63FEA47A2B7D7.png"
    };
}
function creatOKXMiniAppWalletInfo() {
    return {
        "appName": "okxMiniApp",
        "name": exports.OKXMiniWalletName,
        "imageUrl": "https://static.okx.com/cdn/assets/imgs/247/58E63FEA47A2B7D7.png"
    };
}
function creatOKXInjectWalletInfo() {
    return {
        "appName": "okxInjectWallet",
        "name": exports.OKXInjectWalletName,
        "imageUrl": ""
    };
}
